import React from 'react';
import {Map} from 'immutable';

import {Button, Dialogue, Modal, Text} from '@albert-io/atomic';
import {invalidatePartialInterest} from 'resources/mandark.resource';

import {
  getStudentSubmissionQuestionSetsQuery,
  getAssignmentsQuery
} from './ViewStudentSubmission.queries';
import {Assignment} from './ViewStudentSubmission.types';

interface Props {
  assignment: any;
  student: any;
  onClose: () => void;
}

const resetSubmissionStatus = async (student: any, assignment: Assignment) => {
  const updatedStudentModel = student.addRelationship({
    type: 'assignments_v2',
    relation: [assignment.getId()],
    customMeta: Map().set(assignment.getId(), {submitted: null})
  });

  await updatedStudentModel.save();
  invalidatePartialInterest(getStudentSubmissionQuestionSetsQuery);
  invalidatePartialInterest(getAssignmentsQuery);
};

const SubmissionResetWarningModal = ({assignment, student, onClose}: Props) => {
  let message = `Are you sure you want to reset the submit status for "${student.getFullName()}"?`;
  let title = '';
  if (assignment.isOverDue()) {
    message =
      'The student will be not be able to submit or place guesses unless you also change the due date.';
    title = 'Reset a past-due assignment?';
  } else if (assignment.isPastDue()) {
    message =
      'This assignment allows for late submissions. If submitted, the assignment will be marked as "Late" unless you also change the due date.';
    title = 'Reset a past-due assignment?';
  }

  return (
    <Modal
      ariaLabel='Confirm resetting student submission status.'
      className='u-display_flex u-align-items_center u-justify-content_center'
    >
      {({modalContentStyle}) => (
        <Dialogue hideCloseBtn className={modalContentStyle} inModal size='s'>
          {title ? <Dialogue.Title>{title}</Dialogue.Title> : null}
          <Dialogue.Body
            align={title ? 'left' : 'center'}
            className='u-color_slate-700 u-display_flex u-align-items_center u-justify-content_center'
          >
            <Text>{message}</Text>
          </Dialogue.Body>
          <Dialogue.BtnGroup>
            <Button color='secondary' variant='text' onClick={() => onClose()}>
              Cancel
            </Button>
            <Button
              variant='solid'
              color='primary'
              onClick={async () => {
                await resetSubmissionStatus(student, assignment);
                onClose();
              }}
            >
              Reset
            </Button>
          </Dialogue.BtnGroup>
        </Dialogue>
      )}
    </Modal>
  );
};

export default SubmissionResetWarningModal;
